import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { useTranslation } from 'react-i18next'
import { Box, Stack, useColorModeValue } from '@chakra-ui/react'
import DropdownMobileMenu from './dropdownMobileMenu'

const MobileMenu = () => {
    const { i18n } = useTranslation()

    const borderColor = useColorModeValue('gray.200', 'gray.600')

    const data = useStaticQuery(
        graphql`
            query fetchMobileMenu {
                menu: allContentfulMenus(filter: { title: { eq: "MainMenu" } }) {
                    nodes {
                        id
                        title
                        node_locale
                        menuItems {
                            id
                            title
                            megamenu
                            node_locale
                            internal {
                                type
                            }
                            link {
                                ... on ContentfulPage {
                                    id
                                    slug
                                    title

                                    internal {
                                        type
                                    }
                                }
                                ... on ContentfulEduPage {
                                    id
                                    slug
                                    title

                                    internal {
                                        type
                                    }
                                }
                                ... on ContentfulRegistrations {
                                    id
                                    internal {
                                        type
                                    }
                                    title
                                    slug
                                }
                                ... on ContentfulMenulink {
                                    id
                                    internal {
                                        type
                                    }
                                    title
                                    linkTo
                                }
                            }
                            subItems {
                                ... on ContentfulPage {
                                    id
                                    internal {
                                        type
                                    }
                                    title
                                    slug
                                }
                                ... on ContentfulRegistrations {
                                    id
                                    internal {
                                        type
                                    }
                                    title
                                    slug
                                }
                                ... on ContentfulMenulink {
                                    id
                                    internal {
                                        type
                                    }
                                    title
                                    linkTo
                                }
                                ... on ContentfulEduPage {
                                    id
                                    internal {
                                        type
                                    }
                                    title
                                    slug
                                }
                                ... on ContentfulMenuItems {
                                    id
                                    title
                                    link {
                                        ... on ContentfulPage {
                                            id
                                            slug
                                            title
                                            internal {
                                                type
                                            }
                                        }
                                    }
                                    internal {
                                        type
                                    }
                                    subItems {
                                        ... on ContentfulEduPage {
                                            id
                                            internal {
                                                type
                                            }
                                            title
                                            slug
                                        }
                                        ... on ContentfulMenuItems {
                                            id
                                            title
                                            internal {
                                                type
                                            }
                                            link {
                                                ... on ContentfulEduPage {
                                                    id
                                                    title
                                                    slug
                                                    internal {
                                                        type
                                                    }
                                                }
                                                ... on ContentfulPage {
                                                    id
                                                    title
                                                    slug
                                                    internal {
                                                        type
                                                    }
                                                }
                                                ... on ContentfulEducationalLevels {
                                                    id
                                                    slug
                                                    title
                                                    order
                                                    internal {
                                                        type
                                                    }
                                                }
                                            }
                                        }
                                        ... on ContentfulPage {
                                            id
                                            internal {
                                                type
                                            }
                                            title
                                            slug
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `
    )

    return (
        <Box>
            {data.menu.nodes.map(
                (item) =>
                    item.node_locale === i18n.language && (
                        <Stack key={item.id} direction={'column'} flexWrap={'wrap'} justifyContent={'flex-end'}>
                            {item.menuItems.map((menu_item) => (
                                <Box
                                    key={menu_item.title}
                                    mt={'0 !important'}
                                    borderBottom={'1px solid'}
                                    borderColor={borderColor}
                                >
                                    <DropdownMobileMenu menu={menu_item} />
                                </Box>
                            ))}
                        </Stack>
                    )
            )}
        </Box>
    )
}

export default MobileMenu
